export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14716.da6ba264.jpg";